"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../redux/reducers/authentication/actions");
var LoginForm_1 = __importDefault(require("./components/LoginForm"));
var LoginForm_2 = __importDefault(require("./components/v2/LoginForm"));
var styles_2 = __importDefault(require("./styles"));
var LoginScreen = function (_a) {
    var onLoginCallback = _a.onLoginCallback, _b = _a.mainTitleComponent, mainTitleComponent = _b === void 0 ? 'h1' : _b, disableAutofill = _a.disableAutofill, isLoginV2 = _a.isLoginV2;
    var showSuspendMessage = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }).showSuspendMessage;
    var theme = (0, styles_1.useTheme)();
    var classes = (0, styles_2.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var isLoggedIn = (0, react_redux_1.useSelector)(function (state) { return state.authentication; }).isAuthenticated;
    react_1.default.useEffect(function () {
        return function () {
            dispatch((0, actions_1.reset)());
        };
    }, []);
    if (isLoggedIn) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: classes.loginScreen },
        react_1.default.createElement(Grid_1.default, { className: classes.container, container: true, justifyContent: "center" },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 11, sm: 11, md: 6 },
                react_1.default.createElement(Card_1.default, { raised: true, className: classes.loginCard },
                    react_1.default.createElement(CardContent_1.default, { className: classes.loginCardContent },
                        react_1.default.createElement("div", { className: classes.loginCardContentInner },
                            react_1.default.createElement(Typography_1.default, { component: "h2", variant: "h2", className: classes.titleText }, t('login.signIn')),
                            showSuspendMessage && (react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "center", item: true, xs: 12, className: classes.errorText },
                                react_1.default.createElement(Typography_1.default, { color: "error", variant: "body1" },
                                    t('login.accountSuspended'),
                                    " ",
                                    react_1.default.createElement("a", { href: "/feedback" }, t('login.support')),
                                    "."))),
                            !isLoginV2 ? (react_1.default.createElement(LoginForm_1.default, { successCallback: onLoginCallback, disableAutofill: disableAutofill })) : (react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "center" },
                                react_1.default.createElement(LoginForm_2.default, { successCallback: onLoginCallback, disableAutofill: disableAutofill }))))))))));
};
exports.default = LoginScreen;
//# sourceMappingURL=index.js.map